module.exports = __webpack_public_path__ + "img/message.2d48beb5.svg";